<template>
  <div class="mt-3 h-75">
    <div class="search">
      <custom-input
        v-model="searchText"
        placeholder="Wyszukaj klienta"
        type="text"
      />
    </div>
    <div class="box h-75">
      <div
        v-for="balance in filteredClients"
        :key="balance.id"
      >
        <div
          class="w-100 mx-1"
          :class="balance.id===selected?'bg-primary':''"
          @click="selectClient(balance)"
        >
          {{ balance.client.fullname }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  computed, reactive, ref, watch,
} from 'vue';

import { urlBuilder } from '../../plugins/helpers';
import CustomInput from '../common/CustomInput.vue';

export default {
  name: 'ChildrenSingleSelectBox',
  components: { CustomInput },
  setup(props, { emit }) {
    const data = reactive({ balance: [] });
    const selected = ref(null);

    async function getClients() {
      data.balance = (await axios.get(urlBuilder('/balance/'))).data;
    }
    getClients();

    function selectClient(balance) {
      selected.value = balance.id;
      emit('balanceChange', selected.value);
    }

    const searchText = ref('');

    const filteredClients = computed(() => {
      let response = data.balance;
      if (searchText.value.length) {
        response = data.balance.filter((balance) => balance.client.fullname.toLowerCase().includes(
          searchText.value.toLowerCase(),
        ));
      }
      return response;
    });

    watch(() => filteredClients.value, () => { selected.value = null; });

    return {
      filteredClients,
      searchText,
      selected,
      selectClient,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.box {
  border: 1px solid $light-grey;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
